import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { CONSTANTS } from "../constants/constants";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class VesselTrackingService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  public getVesselsV2(poolId: string, page: number = 1, pageSize: number = 50) {
    let url = environment.BASE_API_URL + CONSTANTS.API.VESSEL.V2.VESSELS;
    const params = {
      pools: poolId,
      page: page.toString(),
      pageSize: pageSize.toString(),
      vesselName: "",
    };
    return this.http.get<any>(url, { ...this.headers, params });
  }

  public getVesselsDetail(imo: number) {
    let url =
      environment.BASE_API_URL + CONSTANTS.API.VESSEL.V2.VESSEL_IMO + imo;
    return this.http.get<any>(url, { ...this.headers });
  }

  public getVessels(poolId: number) {
    let url = environment.BASE_API_URL + CONSTANTS.API.VESSEL.VESSELS;
    return this.http.get<any>(url, {
      ...this.headers,
      params: { poolId: poolId.toString() },
    });
  }

  public getDataTracking(data: {
    poolId: number;
    vesselIds: number[];
    fromDate: Date;
    toDate: Date;
  }) {
    let url = environment.BASE_API_URL + CONSTANTS.API.VESSEL.TRACKING;
    return this.http.post<any>(url, data, this.headers);
  }
}
